import SessionPageContainer from "@/features/sessions/containers/session-page-container";
import { createFileRoute } from "@tanstack/react-router";

// Inferred path (child of $clientId): /app/clients/$clientId/session/$eventId
export const Route = createFileRoute("/app/clients/$clientId/session/$eventId")(
  {
    component: SessionPageContainer,
  }
);
